import { Component, Vue, Watch } from 'vue-property-decorator'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faTrashAlt, faEdit } from '@fortawesome/free-solid-svg-icons'

import Loader from '@/components/Loader/index.vue'

import api from '@/helpers/fetch'
import Fuse from 'fuse.js'
let fuse = new Fuse([], {})

library.add(faTrashAlt, faEdit)

@Component({
	components: {
		Loader,
	},
})
export default class DomainCourthouses extends Vue {
	loading = false
	modalLoading = false
	options = [] as Array<any>
	filter = ''

	form = {
		id: '',
		name: '',
	}

	get filteredOptions() {
		// @ts-ignore
		return this.filter.length
			? fuse.search(this.filter).map(({ item }) => item)
			: this.options
	}

	async init() {
		this.options.length = 0

		this.loading = true
		const res = await api.get('/api/courthouses')
		this.loading = false
		this.options.length = 0
		this.options.push(
			...res.data.map((option) => {
				const hasThermometer = option.thermometers_aggregate.aggregate.count > 0
				const hasTrial = option.trials_aggregate.aggregate.count > 0
				Object.assign(option, { loading: false, hasTrial: hasTrial, hasThermometer: hasThermometer })
				return option
			}),
		)
		// @ts-ignore
		fuse = new Fuse(this.options, {
			keys: ['name'],
		})
	}

	clearForm() {
		this.form.id = ''
		this.form.name = ''
		this.modalLoading = false
	}

	openEdit(courthouse) {
		this.form.id = courthouse.id
		this.form.name = courthouse.name
		this.$bvModal.show('modal-edit-courthouse')
	}

	openNew() {
		this.clearForm()
		this.$bvModal.show('modal-new-courthouse')
	}

	async saveEdit() {
		if (!this.form.name) {
			this.$bvToast.toast(`O campo 'nome' é obrigatório!`, {
				title: 'Alerta!',
				autoHideDelay: 2500,
				appendToast: true,
				variant: 'warning',
				toaster: 'b-toaster-top-center',
				solid: true,
			})
		} else {
			try {
				this.modalLoading = true
				const courthouse = this.options.find(
					(courthouse) => courthouse.id === this.form.id,
				)
				const res = await api.post(
					'/api/courthouses/' + courthouse.id,
					this.form,
				)
				if (res.ok) {
					courthouse.name = this.form.name
					this.$bvModal.hide('modal-edit-courthouse')
					this.$bvToast.toast('Escritório salvo com sucesso!', {
						title: 'Sucesso!',
						autoHideDelay: 2500,
						appendToast: true,
						variant: 'success',
						toaster: 'b-toaster-top-center',
						solid: true,
					})
				} else {
					this.$bvToast.toast('Ocorreu um erro inesperado!', {
						title: 'Erro!',
						autoHideDelay: 5000,
						appendToast: true,
						variant: 'danger',
						toaster: 'b-toaster-top-center',
						solid: true,
					})
				}
			} catch (error) {
				this.$bvToast.toast(
					'Ocorreu um erro ao processar a requisição!',
					{
						title: 'Erro!',
						autoHideDelay: 5000,
						appendToast: true,
						variant: 'danger',
						toaster: 'b-toaster-top-center',
						solid: true,
					},
				)
			} finally {
				this.modalLoading = false
			}
		}
	}

	async saveNew() {
		if (!this.form.name) {
			this.$bvToast.toast(`O campo 'nome' é obrigatório!`, {
				title: 'Alerta!',
				autoHideDelay: 2500,
				appendToast: true,
				variant: 'warning',
				toaster: 'b-toaster-top-center',
				solid: true,
			})
		} else {
			try {
				this.modalLoading = true
				const res = await api.post('/api/courthouses/', this.form)
				if (res.ok) {
					this.options.push({
						id: res.data.id,
						name: this.form.name,
						loading: false,
					})

					// @ts-ignore
					fuse = new Fuse(this.options, {
						keys: ['name'],
					})

					this.$bvModal.hide('modal-new-courthouse')
					this.$bvToast.toast('Escritório adicionado com sucesso!', {
						title: 'Sucesso!',
						autoHideDelay: 2500,
						appendToast: true,
						variant: 'success',
						toaster: 'b-toaster-top-center',
						solid: true,
					})
				} else {
					this.$bvToast.toast(res.msg, {
						title: 'Erro!',
						autoHideDelay: 5000,
						appendToast: true,
						variant: 'danger',
						toaster: 'b-toaster-top-center',
						solid: true,
					})
				}
			} catch (error) {
				this.$bvToast.toast(
					'Ocorreu um erro ao processar a requisição!',
					{
						title: 'Erro!',
						autoHideDelay: 5000,
						appendToast: true,
						variant: 'danger',
						toaster: 'b-toaster-top-center',
						solid: true,
					},
				)
			} finally {
				this.modalLoading = false
			}
		}
	}

	async deleteCourtHouse(courtHouse, index) {
		const res = await api.delete('/api/courthouses/', courtHouse)
		if (res.ok) {
			this.options.splice(index, 1)
			this.filter = this.filter.length ? '' : this.filter
			this.$bvToast.toast(
				'Tribunal excluído com sucesso!',
				{
					title: 'Sucesso!',
					autoHideDelay: 2500,
					appendToast: true,
					variant: 'success',
					toaster: 'b-toaster-top-center',
					solid: true,
				},
			)
		} else {
			this.$bvToast.toast('Ocorreu um erro inesperado!', {
				title: 'Erro!',
				autoHideDelay: 2500,
				appendToast: true,
				variant: 'danger',
				toaster: 'b-toaster-top-center',
				solid: true,
			})
		}
	}

	mounted() {
		this.init()
	}
}
